
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.292 11.496L12.498.702A2.415 2.415 0 0010.8 0H2.4A2.4 2.4 0 000 2.4v8.4c0 .666.27 1.266.708 1.698l10.8 10.8A2.39 2.39 0 0013.2 24c.66 0 1.266-.27 1.698-.702l8.4-8.4A2.415 2.415 0 0024 13.2c0-.666-.27-1.266-.708-1.704zM4.2 6c-.996 0-1.8-.804-1.8-1.8s.804-1.8 1.8-1.8S6 3.204 6 4.2 5.196 6 4.2 6z","fill":"#838383"}})])
          )
        }
      }
    